import { render } from "./LoginPanel.vue?vue&type=template&id=c4c972d8"
import script from "./LoginPanel.vue?vue&type=script&lang=js"
export * from "./LoginPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__